import tqlBillRateEditCursorUrl from './assets/tql-bill-rate-edit-cursor.svg';

/** CSS cursor value: Lucide Pencil asset; hotspot at the nib. */
export const tqlBillRateEditCursor = `url(${tqlBillRateEditCursorUrl}) 2 22, default`;
